import { queryOptions } from "@tanstack/react-query";

import { api } from "@platform/core/api";
import type { UsageBucket, UsageRange, UsageSeries, UsageSummary } from "./usage.types";

export function usageSeriesQueryOptions(range: UsageRange, bucket: UsageBucket) {
	return queryOptions({
		queryKey: ["usage", range, bucket],
		queryFn: () => api.get<UsageSeries>(`/platform/usage?range=${range}&bucket=${bucket}`),
	});
}

export function usageSummaryQueryOptions(range: UsageRange) {
	return queryOptions({
		queryKey: ["usage", "summary", range],
		queryFn: () => api.get<UsageSummary>(`/platform/usage/summary?range=${range}`),
	});
}
